import { render } from "./BookmarkBody.vue?vue&type=template&id=2a0284d5&scoped=true"
import script from "./BookmarkBody.vue?vue&type=script&lang=js"
export * from "./BookmarkBody.vue?vue&type=script&lang=js"

import "./BookmarkBody.vue?vue&type=style&index=0&id=2a0284d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0284d5"]])

export default __exports__